import React, { useEffect, useState } from "react";
import "./styles.scss";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  FormHeader,
  ImageComponent,
  InputBox,
  Uploader,
} from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import { useDispatch, useSelector } from "react-redux";
import { Store } from "react-notifications-component";
import {
  createNewJobsCategory,
  updateJobCategory,
} from "../CreateNewJob/service/jobs.service";
import { deleteImage } from "../../../components/imageComponent/service/upload.service";

const CreateNewJobsCategory = (props) => {
  const dispatch = useDispatch();
  const selectJobCategory = useSelector(
    (state) => state.jobsReducer.selectJobCategory
  );

  const [language, setLanguage] = useState("si");

  const [formData, setFormData] = useState({
    jobsCategory: {
      key: "jobsCategory",
      label: "Job Category Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    imageUrl: {
      key: "imageUrl",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Type your image URL",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState("");

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateForm);
    }
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }
    setImage([]);
    setFormData(updateForm);
    props.refresh();
  };

  const onClickAdd = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const updateForm = { ...formData };
    if (updateForm.imageUrl.value === "") {
      setIsLoading(false);
      return;
    }
    let file = {
      file_url: updateForm.imageUrl.value,
      file_name: updateForm.imageUrl.value?.replace(
        "https://hopeofanewera.s3.ap-southeast-1.amazonaws.com/",
        ""
      ),
    };

    setImage(file);
    setFormData({
      ...formData,
      imageUrl: {
        ...formData.imageUrl,
        value: "",
        isValid: false,
        touched: false,
      },
    });
    setIsLoading(false);
  };

  useEffect(() => {
    if (selectJobCategory?.job_category_id) {
      console.log("id", selectJobCategory.job_category_id);
      const updatedForm = {
        ...formData,
      };
      updateForm["jobsCategory"].value = selectJobCategory.jobs_category_name;
      setImage(selectJobCategory.logo);

      setFormData(updatedForm);
    } else {
      for (let key in updateForm) {
        console.log(updateForm[key]);
        updateForm[key].value = "";
        updateForm[key].isValid = false;
        updateForm[key].touched = false;
      }
      setFormData(updateForm);
    }
  }, [selectJobCategory]);

  const onChangeImage = (imageData) => {
    setImage(imageData);
    console.log("image logo", imageData.file_url);
  };

  const onClickRemoveImage = async (key) => {
    setIsLoading(true);
    try {
      const res = await deleteImage(key);
      console.log("remove image", res);

      setImage("");
      if (res?.data) {
        Store.addNotification({
          title: "Success",
          message: "Image Delete successfully",
          type: "success",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
      }

      setIsLoading(false);
    } catch (error) {
      console.log("Error in deleting image", error);
      Store.addNotification({
        title: "Error",
        message: "Image Delete failed",
        type: "danger",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
  };

  const onClickCreate = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    const updateForm = { ...formData };

    const response = await createNewJobsCategory({
      logo: image?.file_url,
      jobs_category_name: updateForm.jobsCategory.value,
    });
    console.log("Jobs Category Response:", response);
    setIsLoading(false);

    try {
      if (response?.data) {
        console.log("Jobs Category Created Successfully");
        Store.addNotification({
          title: "Success!",
          message: "Jobs Category Created Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
        clearAll();
      }
    } catch (error) {
      console.log("Error creating Jobs Category");
      Store.addNotification({
        title: "Error!",
        message: "Jobs Category Create Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      setIsButtonDisabled(false);
      clearAll();
    }
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);
    if (selectJobCategory?.job_category_id) {
      const updateForm = { ...formData };
      const body = {
        logo: image,
        jobs_category_name: updateForm.jobsCategory.value,
      };
      const response = await updateJobCategory(
        body,
        selectJobCategory?.job_category_id
      );
      console.log("Jobs Category Response:", response);
      setIsLoading(false);
      try {
        if (response?.data) {
          console.log("Jobs Category Updated Successfully");
          // dispatch(updateJobCategory(response?.data));

          Store.addNotification({
            title: "Success!",
            message: "Jobs Category Updated Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setIsButtonDisabled(false);
          clearAll();
        }
      } catch (error) {
        console.log("Error updating Jobs Category");
        Store.addNotification({
          title: "Error!",
          message: "Jobs Category Update Failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
        clearAll();
      }
    }
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-create-job-category-wrapper">
        <FormHeader
          data={{
            formHeader: "Create Job Category",
            size: "md-md",
          }}
        />
        <div className="hne-jb-cetgory-header-wrapper">
          <div className={"hne-cjcw-uploader-lable"}>Logo</div>
          <div className="d-flex flex-row align-items-center justify-content-between">
            <InputBox
              data={updateForm.imageUrl}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(e.target.value, updateForm.imageUrl.key);
              }}
            />
            <div className="d-flex ml-2">
              <Button
                data={{
                  btnName: "Add",
                  buttonType: "secondary",
                  buttonSize: "md",
                  isLoading: isLoading,
                  disable:
                    updateForm.imageUrl.value === "" ||
                    !updateForm.imageUrl.isValid,
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  await onClickAdd(e);
                }}
              />
            </div>
          </div>
          <div
            className={"d-flex flex-row align-items-center "}
            style={{ gap: "5px" }}
          >
            {image && (
              <>
                <ImageComponent
                  data={{
                    size: "md mt-3",
                    imgUrl: image?.file_url,
                  }}
                  onClickRemove={() => {
                    setIsLoading(true);
                    if (selectJobCategory?.job_id) {
                      setImage("");
                    } else {
                      onClickRemoveImage(image?.file_name, "image");
                    }
                    setIsLoading(false);
                  }}
                />
              </>
            )}

            <Uploader
              data={{
                disabled: false,
                isLable: true,
                // uploaderLable: "Banner image (1000x 720)",
                iconName: "upload-cloud",
              }}
              onChange={onChangeImage}
            />
          </div>

          <InputBox
            data={updateForm.jobsCategory}
            onChange={async (e) => {
              e.preventDefault();
              await handleChange(e.target.value, updateForm.jobsCategory.key);
            }}
          />
        </div>

        <Button
          data={{
            btnName: selectJobCategory?.job_category_id ? "UPDATE" : "DONE",
            buttonType:
              updateForm.jobsCategory.value === ""
                ? "primary disabled"
                : "primary",
            buttonSize: "lg",
            isLoading: isLoading,
            disable: updateForm.jobsCategory.value === "" ? true : false,
          }}
          onClick={async (e) => {
            e.preventDefault();
            if (selectJobCategory?.job_category_id) {
              await onClickUpdate(e);
            } else {
              await onClickCreate(e);
            }
          }}
        />
      </div>
    </>
  );
};
export default withRouter(CreateNewJobsCategory);
